module.exports = __webpack_public_path__ + "img/img_3.4340d447.png";